import React, { Fragment } from 'react'

import { Profile, LoadingStates } from '@dashboard/lib/types'
import { fullName } from '@dashboard/lib/profile'
import Button from '@dashboard/components/Button'
import Card from '@dashboard/components/Card'
import CardHeader from '@dashboard/components/CardHeader'

import LoadingBox from '@dashboard/components/LoadingBox'
import ComparisonProfileImage from '@dashboard/components/ComparisonProfileImage'
import Link from 'next/link'

import css from './styles.module.scss'

interface OwnProps {
  profile: Profile
  otherCelebritiesResult?: Profile[]
  otherCelebritiesState?: LoadingStates
}
interface State {
  showSidebar: boolean
}

export default class CelebInfo extends React.Component<OwnProps, State> {
  constructor(props: OwnProps) {
    super(props)

    this.state = {
      showSidebar: false,
    }
  }

  componentDidMount() {
    this.setState({ showSidebar: true })
  }

  render() {
    const { profile } = this.props

    return (
      <Fragment>
        <Card noPadding>
          <CardHeader title="Create free account" />
          <div className={css.container}>
            <p>Crystal is an app that tells you anyone&apos;s personality.</p>
            <Button noMargin href={`/app/register?profile_id=${profile.id}`}>
              Sign Up Free
            </Button>
          </div>
        </Card>
        {this.renderOtherCelebrities()}
        {this.renderCelebrityCard()}
      </Fragment>
    )
  }

  renderOtherCelebrities() {
    const { profile } = this.props
    const { showSidebar } = this.state

    if (!showSidebar || profile.type !== 'celebrity') return null

    return (
      <Card noPadding>
        <CardHeader title="Explore Others" />
        {this.renderOtherCelebContent()}
        <div className={css.viewAllLink}>
          <Link href="/famous-people" passHref>
            View all
          </Link>
        </div>
      </Card>
    )
  }

  renderOtherCelebContent() {
    const { otherCelebritiesState } = this.props

    if (otherCelebritiesState === 'loading') {
      return <LoadingBox text="Loading Celebrities" />
    } else {
      return (
        <div className={css.otherCelebrities}>
          {this.otherCelebrities().map(this.renderCelebrity)}
        </div>
      )
    }
  }

  renderCelebrity = (celeb: Profile) => {
    const profileId = celeb.vanity_url

    return (
      <Link
        key={celeb.id}
        href="/personality/[profileId]"
        as={`/personality/${profileId}`}
        className={css.celebRowLink}
        passHref
      >
        <div className={css.celebPhotoContainer}>
          <ComparisonProfileImage
            photoURL={celeb.photo_url}
            fullName={fullName(celeb)}
            size={36}
          />
        </div>
        <div className={css.celebName}>{fullName(celeb)}</div>
      </Link>
    )
  }

  renderCelebrityCard() {
    const { profile } = this.props

    if (profile.type !== 'celebrity') return null

    return (
      <Card noPadding>
        <CardHeader title="What is this profile?" />
        <div className={css.container}>
          <p>
            This is a predicted personality created by Crystal. It is not
            officially affiliated or endorsed by {fullName(profile)}.
          </p>
        </div>
      </Card>
    )
  }

  // Functions
  otherCelebrities() {
    const { otherCelebritiesResult, profile } = this.props
    const otherCelebs = (otherCelebritiesResult || []).filter(
      c => c.id !== profile.id,
    )
    const celebs: Profile[] = []

    for (let i = 0; i < 3; i++) {
      const randomCeleb = otherCelebs
        .sort(() => (Math.random() > 0.5 ? -1 : 1))
        .pop()

      if (randomCeleb) celebs.push(randomCeleb)
    }

    return celebs
  }
}
